import { createTheme } from "@mui/material";
const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
        },
    },
    typography: {
        fontFamily: [
            "Open Sans",
            "-apple-system",
            "BlinkMacSystemFont",
            "Segoe UI",
            "Roboto",
            "Helvetica Neue",
            "Arial",
            "sans-serif",
            "Apple Color Emoji",
            "Segoe UI Emoji",
            "Segoe UI Symbol",
        ].join(","),
    },

    palette: {
        mode: "light",
        primary: {
            main: "#E6117B",
            // light: will be calculated from palette.primary.main,
            light: "rgba(230,17,123,0.91)",
            // dark: will be calculated from palette.primary.main,
            dark: "#b0105e",
            // contrastText: will be calculated to contrast with palette.primary.main
            contrastText: "#fff",
        },
        secondary: {
            light: "#02334E",
            main: "#02334E",
            // dark: will be calculated from palette.secondary.main,
            contrastText: "#ffcc00",
        },
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: 3,
        // Used by the functions below to shift a color"s luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: 0.2,
    },
});

export default theme;
